import { Component, Inject, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MenuItem } from 'primeng/api';
import { RutaCriticaService } from './services/ruta-critica.service';
import { SessionService } from '@shared/helpers/sesion.service';
import { MessageService } from 'primeng/api';
import { IEditarActividadRequest, IGuardarActividadRequest } from './interfaces/ruta-critica.interface';

@Component({
  selector: 'app-actividad-form-dialog',
  templateUrl: './actividad-form-dialog.component.html'
})
export class ActividadFormDialogComponent implements OnInit, OnChanges {
  @Input() model: any = null;
  @Input() visible: boolean = false;
  @Input() numeroProceso: number = 0;
  @Output() visibleChange = new EventEmitter<{ refresh: boolean, success: boolean, message: string }>();

  form: FormGroup;
  accionForm: FormGroup;
  responsableForm: FormGroup;
  renumerarForm: FormGroup;
  displayRenumerarDialog: boolean = false;
  tiposActividad = [
    { name: 'Tipo 1', value: 'TIPO1' },
    { name: 'Tipo 2', value: 'TIPO2' },
    { name: 'Tipo 3', value: 'TIPO3' }
  ];

  cuestionarios: any[] = [];

  claves = [
    { name: '-------', value: 'NONE' },
    { name: 'Ca', value: 'Ca' },
    { name: 'An', value: 'An' },
    { name: 'Us', value: 'Us' }
  ];

  acciones = [
    { name: '-------', value: 'NONE' },
    { name: 'Ca', value: 'Ca' },
    { name: 'An', value: 'An' },
    { name: 'Us', value: 'Us' }
  ];

  responsables: any[] = [];
  loading: boolean = false;

  items: MenuItem[] = [
    { label: 'General' },
    { label: 'Acción a Tomar' },
    { label: 'Responsable' }
  ];
  activeTab: MenuItem = this.items[0];
  activeTabIndex: number = 0;

  dependenciaOptions: any[] = [];
  diasSemana = [
    { label: 'Lunes', value: 0 },
    { label: 'Martes', value: 1 },
    { label: 'Miércoles', value: 2 },
    { label: 'Jueves', value: 3 },
    { label: 'Viernes', value: 4 },
    { label: 'Sábado', value: 5 },
    { label: 'Domingo', value: 6 }
  ];
  diasSeleccionados: boolean[] = [true, true, true, true, true, true, false]; // Por defecto lunes a sábado

  tipoActividadOptions: any[] = [];

  dependenciasConTipoActividad = [
    'Analist', 'Cliente', 'FaxServ', 'Interno', 'Invest', 'TermInv', 'Asigna'
  ];

  esAsigna: boolean = false;
  esAutorizada: boolean = false;
  decisionTexto: string = 'SI|NO|FALTANTES|YA EXISTEN';
  motivosOptions: any[] = [];

  casoActual: string = '';

  buroextDecisionTexto: string = 'SINBUROEXTERNO|CONBUROEXTERNO|bloqueado';
  burointDecisionTexto: string = 'SINBUROINTERNO|CONBUROINTERNO|';
  repBuroDecisionTexto: string = 'CONCTAS|SIN CTAS|SIN BURO|';

  calbextDecisionTexto: string = 'EXCELENTE|BUENA|REGULAR|MALA|BOLETIN|';

  chcklistDecisionTexto: string = 'REALIZACUMPLE|REALIZANOCUMPLE|NO|';

  checklistOptions: any[] = [];

  documentoOptions: any[] = [];
  documentoDecisionTexto: string = 'CAPTURADO|NOCAPTURADO|';

  estatusDecisionTexto: string = 'Proceso|RechazadaPrescoring|RechazadaScoring|Autorizada|Comprada|Devolucion|Cancelada|';

  pantVarOptions: any[] = [];
  campoOptions: any[] = [];
  variableOptions: any[] = [];

  reportes: any[] = [];
  reporteSeleccionado: string = '';

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ActividadFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private rutaCriticaService: RutaCriticaService,
    private sessionService: SessionService,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      numero_actividad: [''],
      descripcion: [''],
      dependencia: [''],
      dias: [0],
      horas: [0],
      minutos: [0],
      costo_estimado: [0],
      dias_semana: ['1111110'],
      tipo_actividad: [''],
      motivo: [''],
      campo: [''],
      variable: [''],
      decision: ['']
    });

    this.accionForm = this.fb.group({
      cuestionario: [''],
      clave: ['']
    });

    this.responsableForm = this.fb.group({
      accion: [''],
      responsable: ['']
    });

    this.renumerarForm = this.fb.group({
      origen: [{ value: '', disabled: true }],
      destino: ['']
    });

    // Suscribirse a los cambios en el campo accion para actualizar los responsables
    this.responsableForm.get('accion')?.valueChanges.subscribe(accion => {
      if (accion === 'NONE') {
        // Limpiar antes de cargar usuarios
        this.responsableForm.get('responsable')?.setValue('');
        this.cargarUsuarios();
      } else {
        this.responsables = [];
        this.responsableForm.get('responsable')?.setValue('');
      }
    });
  }

  ngOnInit(): void {
    this.obtenerDependencias();
    this.actualizarDiasSemana();
    this.obtenerReportesClave();
    this.form.get('dependencia')?.valueChanges.subscribe(dep => {
      console.log('Valor de dependencia seleccionado:', dep);
      this.esAsigna = dep === 'Asigna';
      this.esAutorizada = dep === 'Autorizada';

      // Limpiar campos cuando cambia la dependencia
      this.form.get('campo')?.setValue('');
      this.form.get('variable')?.setValue('');
      this.variableOptions = [];

      // Suscribirse a cambios en el campo para cargar variables
      this.form.get('campo')?.valueChanges.subscribe(campo => {
        if (campo) {
          this.obtenerVariables(campo);
        } else {
          this.variableOptions = [];
          this.form.get('variable')?.setValue('');
        }
      });

      switch (dep) {
        case 'VerCheck':
          this.casoActual = 'vercheck';
          this.form.get('tipo_actividad')?.enable();
          this.obtenerPantVar();
          break;
        case 'Texto':
          this.casoActual = 'texto';
          this.form.get('tipo_actividad')?.enable();
          this.obtenerReportes();
          break;
        case 'Asigna':
          this.casoActual = 'asigna';
          this.form.get('tipo_actividad')?.setValue('Obligatoria');
          this.form.get('tipo_actividad')?.disable();
          break;
        case 'RepBuro':
          this.casoActual = 'repburo';
          this.form.get('tipo_actividad')?.disable();
          this.obtenerTipoActividad(() => {
            this.form.get('tipo_actividad')?.setValue('Obligatoria');
          });
          break;
        case 'Rechazada':
          this.casoActual = 'rechazada';
          this.form.get('tipo_actividad')?.enable();
          this.obtenerMotivosAutorizada('Rechazo');
          break;
        case 'Proceso':
          this.casoActual = 'proceso';
          this.form.get('tipo_actividad')?.enable();
          this.obtenerMotivosAutorizada('Proceso');
          break;
        case 'POP':
          this.casoActual = 'pop';
          this.form.get('tipo_actividad')?.enable();
          this.obtenerCampos();
          break;
        case 'BuroExt':
          this.casoActual = 'buroext';
          this.form.get('tipo_actividad')?.disable();
          this.obtenerTipoActividad(() => {
            this.form.get('tipo_actividad')?.setValue('Obligatoria');
          });
          break;
        case 'Autorizada':
          this.casoActual = 'autorizada';
          this.form.get('tipo_actividad')?.enable();
          this.obtenerMotivosAutorizada('Autorizacion');
          break;
        case 'BuroInt':
          this.casoActual = 'buroint';
          this.form.get('tipo_actividad')?.disable();
          this.obtenerTipoActividad(() => {
            this.form.get('tipo_actividad')?.setValue('Obligatoria');
          });
          break;
        case 'CalBExt':
          this.casoActual = 'calbext';
          this.form.get('tipo_actividad')?.disable();
          this.obtenerTipoActividad(() => {
            this.form.get('tipo_actividad')?.setValue('Obligatoria');
          });
          break;
        case 'CalBInt':
          this.casoActual = 'calbint';
          this.form.get('tipo_actividad')?.disable();
          this.obtenerTipoActividad(() => {
            this.form.get('tipo_actividad')?.setValue('Obligatoria');
          });
          break;
        case 'Cancelada':
          this.casoActual = 'cancelada';
          this.form.get('tipo_actividad')?.enable(); // No se usa aquí
          this.obtenerMotivosAutorizada('Cancelacion');
          break;
        case 'ChckLst':
          this.casoActual = 'chcklst';
          this.form.get('tipo_actividad')?.disable();
          this.obtenerTipoActividad(() => {
            this.form.get('tipo_actividad')?.setValue('Obligatoria');
          });
          break;
        case 'CheckList':
          this.casoActual = 'checklist';
          this.form.get('tipo_actividad')?.enable();
          this.obtenerCatChkLs();
          break;
        case 'Devolucion':
          this.casoActual = 'devolucion';
          this.form.get('tipo_actividad')?.enable();
          this.obtenerMotivosAutorizada('Devolucion');
          break;
        case 'Documento':
          this.casoActual = 'documento';
          this.form.get('tipo_actividad')?.enable();
          this.obtenerCatalogodoc();
          break;
        case 'Estatus':
          this.casoActual = 'estatus';
          this.form.get('tipo_actividad')?.disable();
          this.obtenerTipoActividad(() => {
            this.form.get('tipo_actividad')?.setValue('Obligatoria');
          });
          break;
        case 'PantVar':
          this.casoActual = 'pantvar';
          this.form.get('tipo_actividad')?.enable();
          this.obtenerPantVar();
          break;
        default:
          if (this.dependenciasConTipoActividad.includes(dep)) {
            this.casoActual = 'tipoActividad';
            if (this.tipoActividadOptions.length === 0) {
              this.obtenerTipoActividad();
            }
          } else {
            this.casoActual = '';
          }
          this.form.get('tipo_actividad')?.enable();
          break;
      }

      // Limpieza de campos si no aplica
      if (!['Asigna', 'Autorizada', ...this.dependenciasConTipoActividad].includes(dep)) {
        this.form.get('tipo_actividad')?.setValue('');
      }
    });
    this.obtenerCuestionarios();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model'] && changes['model'].currentValue) {
      this.cargarDatosActividad(changes['model'].currentValue);
    } else if (changes['model'] && !changes['model'].currentValue) {
      this.limpiarFormularios();
    }
  }

  cargarDatosActividad(model: any) {
    const request = {
      numeroProceso: this.numeroProceso,
      numeroActividad: Number(model.numero_actividad),
      descripcion: "",
      tipoActividad: "",
      dependencia: "",
      tiempoEstimado: 0,
      diasSemana: "",
      horas: 0,
      minutos: 0,
      horasDia: "",
      costoEstimado: 0,
      marcajeAutomatico: "",
      envioCarta: "",
      procesoAutomatico: "",
      cuentaCredito: "",
      accion: "",
      resultado: "",
      responsable: "",
      carta: "",
      encuesta: "",
      decisiones: ""
    };

    this.rutaCriticaService.getActivi5(request).subscribe({
      next: (res) => {
        if (res.success && res.data.length > 0) {
          const actividad = res.data[0];
          console.log('Datos recibidos:', actividad);

          // Primero establecer la dependencia para que se carguen las opciones correctas
          this.form.patchValue({
            dependencia: actividad.dependencia
          });

          // Esperar un momento para que se carguen las opciones
          setTimeout(() => {
            // Cargar motivos/tipo_actividad si aplica
            if ([
              'autorizada', 'cancelada', 'devolucion', 'proceso', 'rechazada'
            ].includes(this.casoActual)) {
              this.obtenerMotivosAutorizada();
            } else if ([
              'repburo', 'buroext', 'buroint', 'calbext', 'calbint', 'chcklst', 'estatus', 'tipoActividad', 'asigna'
            ].includes(this.casoActual)) {
              this.obtenerTipoActividad(() => {
                this.form.patchValue({ tipo_actividad: actividad.tipo_actividad });
              });
            } else if (this.casoActual === 'pop') {
              // Caso POP: mapear tipo_actividad a campo y decisiones a variable
              this.obtenerCampos();
              // Esperar a que se carguen los campos antes de establecer el valor
              setTimeout(() => {
                this.form.patchValue({ campo: actividad.tipo_actividad });
                // Cargar variables después de establecer el campo
                if (actividad.tipo_actividad) {
                  this.obtenerVariables(actividad.tipo_actividad);
                  // Esperar a que se carguen las variables antes de establecer el valor
                  setTimeout(() => {
                    this.form.patchValue({ variable: actividad.decisiones });
                  }, 200);
                }
              }, 200);
            } else {
              this.form.patchValue({ tipo_actividad: actividad.tipo_actividad });
            }

            this.form.patchValue({
              numero_actividad: actividad.numero_actividad,
              descripcion: actividad.descripcion,
              dias: actividad.tiempo_estimado,
              horas: actividad.horas,
              minutos: actividad.minutos,
              costo_estimado: actividad.costo_estimado,
              dias_semana: actividad.dias_semana,
              decision: actividad.decisiones,
              motivo: actividad.tipo_actividad
            });

            // Sincronizar los checks de días de la semana
            if (actividad.dias_semana) {
              this.diasSeleccionados = actividad.dias_semana.split('').map(d => d === '1');
            }

            // Para la clave, buscar el valor en el array de claves
            if (actividad.carta) {
              const claveEncontrada = this.claves.find(c => c.name === actividad.carta);
              if (claveEncontrada) {
                this.accionForm.patchValue({
                  clave: claveEncontrada.value
                });
              }
            }

            this.accionForm.patchValue({
              cuestionario: actividad.encuesta
            });

            // Para la acción, buscar el valor en el array de acciones
            if (actividad.responsable) {
              const accionEncontrada = this.acciones.find(a => a.value === actividad.responsable);
              if (accionEncontrada) {
                this.responsableForm.patchValue({
                  accion: accionEncontrada.value,
                  responsable: actividad.responsable
                });
              }
            } else {
              this.responsableForm.patchValue({
                accion: actividad.accion || 'NONE',
                responsable: actividad.responsable
              });
            }

            // Si hay una acción seleccionada y es NONE, cargar los usuarios
            if (actividad.accion === 'NONE' || !actividad.accion) {
              this.cargarUsuarios();
            }

            // Deshabilitar N° Actividad en edición
            if (this.model) {
              this.form.get('numero_actividad')?.disable();
            } else {
              this.form.get('numero_actividad')?.enable();
            }

            // Log para verificar el estado de los formularios
            console.log('Estado de los formularios:', {
              form: this.form.value,
              accionForm: this.accionForm.value,
              responsableForm: this.responsableForm.value,
              casoActual: this.casoActual,
              diasSeleccionados: this.diasSeleccionados
            });
          }, 100);
        }
      },
      error: (error) => {
        console.error('Error al cargar actividad:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar la información de la actividad'
        });
      }
    });
  }

  cargarUsuarios() {
    this.loading = true;
    const request = {
      tope: '999',
      usuario: ''
    };
    this.rutaCriticaService.getUsuarios(request).subscribe({
      next: (res) => {
        if (res.success) {
          this.responsables = res.data.map(usuario => ({
            name: usuario.nombreusuario,
            value: usuario.susuario
          }));
        }
      },
      complete: () => this.loading = false
    });
  }

  obtenerDependencias() {
    const request = {
      sTabla: 'activid',
      sCampo: 'dependencia',
      iIdioma: 0
    };
    this.rutaCriticaService.getOpcionesDependencia(request).subscribe(res => {
      if (res.success) {
        this.dependenciaOptions = res.data.map((item: any) => ({ label: item.sOpcion, value: item.sValor }));
      }
    });
  }

  onDiaSemanaChange(index: number, checked: boolean) {
    this.diasSeleccionados[index] = checked;
    this.actualizarDiasSemana();
  }

  actualizarDiasSemana() {
    this.form.get('dias_semana')?.setValue(this.diasSeleccionados.map(d => d ? '1' : '0').join(''));
  }

  onTabChange(event: any): void {
    this.activeTabIndex = this.items.indexOf(event);
  }

  aceptar(): void {
    // Recolectar datos de los formularios
    const general = this.form.getRawValue();
    const accion = this.accionForm.value;
    const responsable = this.responsableForm.value;

    // Payload para guardar (nuevo)
    const payloadGuardar: IGuardarActividadRequest = {
      numeroProceso: Number(this.numeroProceso),
      numeroActividad: Number(general.numero_actividad),
      descripcion: general.descripcion,
      tipoActividad: general.tipo_actividad,
      dependencia: general.dependencia,
      tiempoEstimado: Number(general.dias),
      diasSemana: general.dias_semana,
      horas: Number(general.horas),
      minutos: Number(general.minutos),
      horasDia: '',
      costoEstimado: Number(general.costo_estimado),
      marcajeAutomatico: '',
      envioCarta: '',
      procesoAutomatico: '',
      cuentaCredito: '',
      accion: '',
      resultado: '',
      responsable: responsable.accion === 'NONE' ? responsable.responsable : responsable.accion,
      carta: this.claves.find(c => c.value === accion.clave)?.name || accion.clave,
      encuesta: accion.cuestionario,
      decisiones: ''
    };

    // Payload para editar
    const payloadEditar: IEditarActividadRequest = {
      que: 2,
      numeroProceso: Number(this.numeroProceso) || 0,
      numeroActividad: Number(general.numero_actividad) || 0,
      descripcion: general.descripcion || '',
      tipoActividad: general.tipo_actividad || '',
      dependencia: general.dependencia || '',
      tiempoEstimado: Number(general.dias) || 0,
      diasSemana: general.dias_semana || '',
      horas: Number(general.horas) || 0,
      minutos: Number(general.minutos) || 0,
      horasDia: '',
      costoEstimado: Number(general.costo_estimado) || 0,
      marcajeAutomatico: '',
      envioCarta: '',
      procesoAutomatico: '',
      cuentaCredito: '',
      accion: '',
      resultado: '',
      responsable: responsable.accion === 'NONE' ? (responsable.responsable || '') : (responsable.accion || ''),
      carta: this.claves.find(c => c.value === accion.clave)?.name || accion.clave || '',
      encuesta: accion.cuestionario || '',
      decisiones: ''
    };

    // Caso POP
    if (this.casoActual === 'pop') {
      payloadGuardar.tipoActividad = general.campo;
      payloadGuardar.decisiones = general.variable;
      payloadEditar.tipoActividad = general.campo;
    }

    // Caso Proceso
    if (this.casoActual === 'proceso') {
      payloadGuardar.tipoActividad = this.form.get('motivo')?.value;
      payloadEditar.tipoActividad = this.form.get('motivo')?.value;
    }

    // Caso Rechazada
    if (this.casoActual === 'rechazada') {
      payloadGuardar.tipoActividad = this.form.get('motivo')?.value;
      payloadEditar.tipoActividad = this.form.get('motivo')?.value;
    }

    // Caso RepBuro
    if (this.casoActual === 'repburo') {
      payloadGuardar.tipoActividad = 'Obligatoria';
      payloadGuardar.decisiones = this.repBuroDecisionTexto;
      payloadEditar.tipoActividad = 'Obligatoria';
      payloadEditar.decisiones = this.repBuroDecisionTexto;
    }

    // Decisiones si existe el input de decisiones (caso Asigna o Buroext)
    if (this.esAsigna) {
      payloadGuardar.decisiones = this.decisionTexto;
      payloadEditar.decisiones = this.decisionTexto;
    }
    if (this.casoActual === 'buroext') {
      payloadGuardar.decisiones = this.buroextDecisionTexto;
      payloadEditar.decisiones = this.buroextDecisionTexto;
    }
    if (this.casoActual === 'buroint') {
      payloadGuardar.decisiones = this.burointDecisionTexto;
      payloadEditar.decisiones = this.burointDecisionTexto;
    }
    if (this.casoActual === 'calbext') {
      payloadGuardar.decisiones = this.calbextDecisionTexto;
      payloadEditar.decisiones = this.calbextDecisionTexto;
    }
    if (this.casoActual === 'calbint') {
      payloadGuardar.decisiones = this.calbextDecisionTexto;
      payloadEditar.decisiones = this.calbextDecisionTexto;
    }
    if (this.casoActual === 'chcklst') {
      payloadGuardar.tipoActividad = 'Obligatoria';
      payloadGuardar.decisiones = this.chcklistDecisionTexto;
      payloadEditar.tipoActividad = 'Obligatoria';
      payloadEditar.decisiones = this.chcklistDecisionTexto;
    }
    if (this.casoActual === 'checklist') {
      payloadGuardar.tipoActividad = general.tipo_actividad;
      payloadGuardar.decisiones = this.chcklistDecisionTexto;
      payloadEditar.tipoActividad = general.tipo_actividad;
      payloadEditar.decisiones = this.chcklistDecisionTexto;
    }
    if (this.casoActual === 'documento') {
      payloadGuardar.tipoActividad = general.tipo_actividad;
      payloadGuardar.decisiones = this.documentoDecisionTexto;
      payloadEditar.tipoActividad = general.tipo_actividad;
      payloadEditar.decisiones = this.documentoDecisionTexto;
    }
    if (this.casoActual === 'estatus') {
      payloadGuardar.tipoActividad = 'Obligatoria';
      payloadGuardar.decisiones = this.estatusDecisionTexto;
      payloadEditar.tipoActividad = 'Obligatoria';
      payloadEditar.decisiones = this.estatusDecisionTexto;
    }
    if (this.casoActual === 'pantvar') {
      payloadGuardar.tipoActividad = general.tipo_actividad;
      payloadEditar.tipoActividad = general.tipo_actividad;
    }

    if (this.casoActual === 'vercheck') {
      payloadGuardar.tipoActividad = general.tipo_actividad;
      payloadEditar.tipoActividad = general.tipo_actividad;
    }

    if (this.casoActual === 'texto') {
      payloadGuardar.tipoActividad = general.tipo_actividad;
      payloadEditar.tipoActividad = general.tipo_actividad;
    }

    // Motivo si es autorizada
    if (this.esAutorizada) {
      payloadGuardar.tipoActividad = this.form.get('motivo')?.value;
      payloadGuardar.accion = '';
      payloadGuardar.carta = '';
      payloadGuardar.encuesta = '';
      payloadGuardar.dependencia = general.dependencia;
      payloadGuardar.descripcion = general.descripcion;
      payloadGuardar.numeroActividad = Number(general.numero_actividad);
      payloadEditar.tipoActividad = this.form.get('motivo')?.value;
      payloadEditar.accion = '';
      payloadEditar.carta = '';
      payloadEditar.encuesta = '';
      payloadEditar.dependencia = general.dependencia;
      payloadEditar.descripcion = general.descripcion;
      payloadEditar.numeroActividad = Number(general.numero_actividad);
    }

    if (this.casoActual === 'cancelada') {
      payloadGuardar.tipoActividad = this.form.get('motivo')?.value;
      payloadEditar.tipoActividad = this.form.get('motivo')?.value;
    }

    if (this.casoActual === 'devolucion') {
      payloadGuardar.tipoActividad = this.form.get('motivo')?.value;
      payloadEditar.tipoActividad = this.form.get('motivo')?.value;
    }

    // Caso tipoActividad
    if (this.dependenciasConTipoActividad.includes(general.dependencia)) {
      if (general.tipo_actividad === 'Decision') {
        payloadGuardar.decisiones = this.form.get('decision')?.value;
        payloadEditar.decisiones = this.form.get('decision')?.value;
      }
    }

    console.log('Payload a guardar:', payloadGuardar);
    console.log('Payload a editar:', payloadEditar);

    // Si es edición, usar getactividVerr2 con payloadEditar
    if (this.model) {
      this.loading = true;
      this.rutaCriticaService.getactividVerr2(payloadEditar).subscribe({
        next: (res) => {
          if (res.success) {
            this.visibleChange.emit({ refresh: true, success: true, message: 'Actividad actualizada correctamente' });
            this.visible = false;
          } else {
            this.visibleChange.emit({ refresh: false, success: false, message: 'Error al actualizar la actividad' });
          }
        },
        error: (error) => {
          console.error('Error al actualizar actividad:', error);
          this.visibleChange.emit({ refresh: false, success: false, message: 'Error al actualizar la actividad' });
        },
        complete: () => {
          this.loading = false;
        }
      });
      return;
    }

    // Si es nuevo, flujo actual con payloadGuardar
    this.loading = true;
    this.rutaCriticaService.guardarActividad(payloadGuardar).subscribe({
      next: (res) => {
        if (res.success) {
          this.visibleChange.emit({ refresh: true, success: true, message: 'Actividad creada correctamente' });
          this.visible = false;
        } else {
          this.visibleChange.emit({ refresh: false, success: false, message: 'Error al guardar la actividad' });
        }
      },
      error: (error) => {
        console.error('Error al guardar actividad:', error);
        this.visibleChange.emit({ refresh: false, success: false, message: 'Error al guardar la actividad' });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  renumerar(): void {
    // Aquí irá la lógica para renumerar la actividad
    console.log('Renumerar actividad:', this.model);
  }

  // Método para obtener las opciones de tipo_actividad (preparado para uso futuro)
  obtenerTipoActividad(callback?: () => void) {
    const request = {
      sTabla: 'activid',
      sCampo: 'tipo_actividad',
      iIdioma: 0
    };
    this.rutaCriticaService.getOpcionesDependencia(request).subscribe(res => {
      if (res.success) {
        this.tipoActividadOptions = res.data.map((item: any) => ({
          label: item.sOpcion,
          value: item.sValor
        }));
        if (callback) callback();
      }
    });
  }

  mostrarTipoActividad(): boolean {
    return this.dependenciasConTipoActividad.includes(this.form.get('dependencia')?.value);
  }

  obtenerMotivosAutorizada(tipo: string = '') {
    const request = {
      que: 6,
      tope: '999',
      cmd: '',
      codigo: '',
      tipo: tipo,
      descripcion: '',
      tipo_motivo: '',
      iIdioma: 0
    };
    this.rutaCriticaService.getMotivosAutorizada(request).subscribe(res => {
      if (res.success) {
        this.motivosOptions = res.data.map((item: any) => ({
          label: `${item.motivo} | ${item.descripcion}`,
          value: item.motivo
        }));
      }
    });
  }

  obtenerCatChkLs() {
    const request = {
      tope: '999',
      numAct: 0,
      descripcion: ''
    };
    this.rutaCriticaService.getCatChkLs(request).subscribe(res => {
      if (res.success) {
        this.checklistOptions = res.data.map((item: any) => ({
          label: `${item.numAct} | ${item.descripcion}`,
          value: item.numAct
        }));
      }
    });
  }

  obtenerCuestionarios() {
    const request = {
      que: '0',
      tope: '999',
      cmd: '',
      sClave: '',
      sDescripcion: '',
      iTipo: 0,
      iGestion: 0,
      bTodos: 0
    };
    this.rutaCriticaService.getCuestionarios(request).subscribe(res => {
      if (res.success) {
        this.cuestionarios = res.data.map((item: any) => ({
          name: `${item.sClaveCues} | ${item.sDescripcion}`,
          value: item.sClaveCues
        }));
      }
    });
  }

  obtenerCatalogodoc() {
    const request = {
      tope: '999',
      clavedocumento: '',
      descripcion: '',
      aplicavigencia: 0,
      score: 0
    };
    this.rutaCriticaService.getCatalogodoc(request).subscribe(res => {
      if (res.success) {
        this.documentoOptions = res.data.map((item: any) => ({
          label: `${item.clavedocumento} | ${item.descripcion}`,
          value: item.clavedocumento
        }));
      }
    });
  }

  obtenerPantVar() {
    const user = this.sessionService.getUserSession();
    const request = {
      sUsuario: user,
      iNumReg: 0
    };
    this.rutaCriticaService.getPantVar(request).subscribe(res => {
      if (res.success) {
        this.pantVarOptions = res.data.map((item: any) => ({
          label: `${item.clave} | ${item.descripcion} | ${item.tipo}`,
          value: item.clave
        }));
      }
    });
  }

  obtenerCampos() {
    const request = {
      tope: '999',
      clave: '',
      descripcion: '',
      scoreInicial: 0,
      modelo: '',
      tarea: '',
      conector: ''
    };
    this.rutaCriticaService.getPerfiles(request).subscribe(res => {
      if (res.success) {
        this.campoOptions = res.data.map(item => ({
          label: `${item.clavePerfil} | ${item.descripcion}`,
          value: item.clavePerfil
        }));
      }
    });
  }

  obtenerVariables(campo: string) {
    const request = {
      tope: '999',
      perfil: campo,
      numero: 0,
      tabla: '',
      tipo: '',
      campo: '',
      sFechaEdo1: '',
      sFechaEdo2: ''
    };
    this.rutaCriticaService.getVariables(request).subscribe(res => {
      if (res.success) {
        this.variableOptions = res.data.map(item => ({
          label: `${item.variable} | ${item.tabla}`,
          value: item.variable
        }));
      }
    });
  }

  obtenerReportes() {
    const request = {
      que: 0,
      tope: "999",
      cmd: "",
      sClave: "",
      sDescripcion: "",
      sTablaPivote: "",
      sXML_File: "",
      sHTML_File: "",
      sXML_Dat: "",
      sCmd: "",
      sUsuario: "",
      sCatalogo: "",
      sMaster: "",
      sTipoCampos: "",
      sModulo: "",
      sSeparador: ""
    };
    this.rutaCriticaService.getReportesList(request).subscribe(res => {
      if (res.success) {
        this.reportes = res.data.map((item: any) => ({
          label: `${item.sClave} | ${item.sDescripcion}`,
          value: item.sClave
        }));
      }
    });
  }

  obtenerReportesClave() {
    const request = {
      que: 0,
      tope: "999",
      cmd: "",
      sClave: "",
      sDescripcion: "",
      sTablaPivote: "",
      sXML_File: "",
      sHTML_File: "",
      sXML_Dat: "",
      sCmd: "",
      sUsuario: "",
      sCatalogo: "",
      sMaster: "",
      sTipoCampos: "",
      sModulo: "",
      sSeparador: ""
    };
    this.rutaCriticaService.getReportesList(request).subscribe(res => {
      if (res.success) {
        this.claves = res.data.map((item: any) => {
          const concatenado = `${item.sClave}|${item.sDescripcion}|${item.sTablaPivote}`.replace(/\s+/g, '');
          return {
            name: concatenado.length > 20 ? concatenado.substring(0, 20) : concatenado,
            value: item.sClave
          };
        });
      }
    });
  }

  onClaveChange(event: any) {
    console.log('Clave seleccionada:', {
      valor: event.value,
      objetoCompleto: this.claves.find(c => c.value === event.value)
    });
  }

  limpiarFormularios() {
    // Limpiar formulario principal
    this.form.reset({
      dias: 0,
      horas: 0,
      minutos: 0,
      costo_estimado: 0,
      dias_semana: '1111110'
    });

    // Limpiar formulario de acción
    this.accionForm.reset({
      cuestionario: '',
      clave: ''
    });

    // Limpiar formulario de responsable
    this.responsableForm.reset({
      accion: '',
      responsable: ''
    });

    // Limpiar arrays de opciones
    this.claves = [];
    this.cuestionarios = [];
    this.responsables = [];
    this.motivosOptions = [];
    this.tipoActividadOptions = [];
    this.pantVarOptions = [];
    this.campoOptions = [];
    this.variableOptions = [];
    this.reportes = [];
    this.checklistOptions = [];
    this.documentoOptions = [];

    // Resetear caso actual
    this.casoActual = '';
    this.esAsigna = false;
    this.esAutorizada = false;

    // Cargar datos necesarios
    this.obtenerReportesClave();
    this.obtenerCuestionarios();
  }

  abrirRenumerarDialog() {
    const numAct = this.form.get('numero_actividad')?.value || '';
    this.renumerarForm.patchValue({ origen: numAct, destino: '' });
    this.displayRenumerarDialog = true;
  }

  cerrarRenumerarDialog() {
    this.displayRenumerarDialog = false;
  }

  guardarRenumerar() {
    const origen = this.renumerarForm.get('origen')?.value;
    const destino = this.renumerarForm.get('destino')?.value;
    const payload: any = {
      que: 6,
      numeroProceso: Number(this.numeroProceso),
      numeroActividad: Number(origen),
      descripcion: String(destino),
      tipoActividad: '',
      dependencia: '',
      tiempoEstimado: 0,
      diasSemana: '',
      horas: 0,
      minutos: 0,
      horasDia: '',
      costoEstimado: 0,
      marcajeAutomatico: '',
      envioCarta: '',
      procesoAutomatico: '',
      cuentaCredito: '',
      accion: '',
      resultado: '',
      responsable: '',
      carta: '',
      encuesta: '',
      decisiones: ''
    };
    this.rutaCriticaService.getactividVerr2(payload).subscribe({
      next: (res) => {
        if (res.success) {
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Actividad renumerada correctamente'
          });
          this.displayRenumerarDialog = false;
          this.visibleChange.emit({ refresh: true, success: true, message: 'Actividad renumerada correctamente' });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo renumerar la actividad'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al renumerar la actividad'
        });
      }
    });
  }
} 